export default __webpack_public_path__ + "static/media/ksivalue_main.2a840ebf.jpg";